<span *ngIf="loading" class="app-spinner mr-5 mt-2"></span>
<alert nom="changelogAlert"></alert>
<div class="container" *ngIf="!loading">
	<!-- message d'erreur provenant du backend -->
	<markdown class="changelog" [data]="changelog"></markdown>
</div>
